import "./Text_module.css";
const Text_module = {
    text: "text__95baced96d7da166",
    ellipsis: "ellipsis__95baced96d7da166"
};
export { Text_module as default };
